import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920 847.053c0 136.32-97.13 250.503-225.882 276.705v513.883c0 26.202-17.958 49.016-43.483 55.002a57.279 57.279 0 0 1-12.988 1.468c-21.12 0-40.772-11.745-50.485-31.171C1379.238 1247.203 964.18 1242.347 960 1242.347H564.706v564.706h87.755c-11.859-90.127-17.506-247.003 63.473-350.683 52.405-67.087 129.657-101.082 229.948-101.082v112.941c-64.49 0-110.57 18.861-140.837 57.487-68.781 87.868-45.064 263.83-30.269 324.254 4.18 16.828.34 34.673-10.277 48.34-10.73 13.665-27.219 21.684-44.499 21.684H508.235c-31.171 0-56.47-25.186-56.47-56.47v-621.177h-56.47c-155.747 0-282.354-126.607-282.354-282.353v-56.47h-56.47C25.299 903.523 0 878.336 0 847.052c0-31.172 25.299-56.471 56.47-56.471h56.471v-56.47c0-155.634 126.607-282.354 282.353-282.354h564.593c16.941-.112 420.48-7.002 627.275-420.48 11.52-23.491 37.27-35.689 63.473-29.816 25.525 6.099 43.483 28.8 43.483 55.002V570.46C1822.87 596.662 1920 710.733 1920 847.053zm-225.882 159.02c65.618-23.378 112.94-85.496 112.94-159.02 0-73.525-47.322-135.53-112.94-158.909v317.93zm-112.942 438.438V249.707c-194.71 242.371-452.216 298.164-564.705 311.04v572.724c112.489 12.876 369.995 68.556 564.705 311.04zM903.53 1129.406V564.7H395.294c-93.402 0-169.412 76.01-169.412 169.411v225.883c0 93.402 76.01 169.412 169.412 169.412H903.53z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAnnouncementLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAnnouncementLine, _Component);

  var _super = _createSuper(IconAnnouncementLine);

  function IconAnnouncementLine() {
    _classCallCheck(this, IconAnnouncementLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAnnouncementLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAnnouncement",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAnnouncementLine.displayName = "IconAnnouncementLine";
  return IconAnnouncementLine;
}(Component);

IconAnnouncementLine.glyphName = 'announcement';
IconAnnouncementLine.variant = 'Line';
IconAnnouncementLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAnnouncementLine;
export { IconAnnouncementLine };